export enum PaymentStatus {
    Processed = 1,
    Reversed = 2,
    Error = 3,
    Preauth = 4,
    Cancelled = 5
}
